// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__nuxt #__layout .wzqS0laP .el-dialog{overflow:hidden}#__nuxt #__layout .wzqS0laP .el-dialog__body{background-color:transparent;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"dialog": "wzqS0laP"
};
module.exports = ___CSS_LOADER_EXPORT___;
